import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * SecciÃ³n de VerificaciÃ³n KYC
 * - Estado, subida de documentos, historial, notas
 * - Extensible para integraciÃ³n con servicios de compliance
 */
export default function KYCSection() {
    return (
        <Box>
            <Typography variant="h6">Estado de VerificaciÃ³n KYC</Typography>
            {/* TODO: Integrar con flujo/documentos de KYC */}
            <Typography variant="body2" color="text.secondary">
                Consulta tu estado de verificaciÃ³n y gestiona tus documentos KYC.
            </Typography>
        </Box>
    );
} 